import { render, staticRenderFns } from "./Addintegration.vue?vue&type=template&id=690b71c4&scoped=true&"
import script from "./Addintegration.vue?vue&type=script&lang=js&"
export * from "./Addintegration.vue?vue&type=script&lang=js&"
import style0 from "./Addintegration.vue?vue&type=style&index=0&id=690b71c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b71c4",
  null
  
)

export default component.exports